import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { alpha } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const getZIndex = _ref => {
  let {
    isHeader,
    isFixed,
    rows,
    rowIndex = 0,
    isLoading
  } = _ref;
  const initZIndex = isHeader ? rows : rows - rowIndex;
  let zIndex = initZIndex;
  if (isFixed) {
    if (isHeader) {
      zIndex = initZIndex + 9;
    } else if (isLoading) {
      zIndex = initZIndex + 5;
    } else {
      zIndex = initZIndex + 4;
    }
  } else if (isHeader) {
    zIndex = initZIndex + 8;
  } else {
    zIndex = initZIndex + 2;
  }
  return zIndex;
};
const StyledTable = /*#__PURE__*/_styled(Table, {
  shouldForwardProp: isStyledPropsValid,
  target: "erzejn97"
})(_ref2 => {
  return {
    borderCollapse: "separate",
    // borderSpacing: `0 5px`,
    border: 'transparent'
    // marginTop: '-5px',
    // '& th, td': {
    // 	borderTop: '1px solid black',
    // 	borderBottom: '1px solid black',
    // },
  };
}, "");
const StyledTableRow = /*#__PURE__*/_styled(TableRow, {
  shouldForwardProp: isStyledPropsValid,
  target: "erzejn96"
})(_ref3 => {
  let {
    theme,
    isRowCanClick,
    isSelected,
    isPinned
  } = _ref3;
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    position: 'relative'
  }, isRowCanClick && {
    '&:hover': {
      ' & td': {
        backgroundColor: '#FAF7FF'
      }
    }
  }), isSelected && {
    ' & td': {
      backgroundColor: '#F6F1FF'
    }
  }), isPinned && {
    ' & td': {
      backgroundColor: '#FAF6FF'
    }
  }), {}, {
    '& th': {
      padding: '12px 8px',
      '&:first-child': {
        borderTopLeftRadius: '4px'
      },
      '&:last-child': {
        borderTopRightRadius: '4px'
      }
    }
  }, isRowCanClick && {
    cursor: 'pointer'
  }), {}, {
    '& td': {
      // position: 'relative',
      padding: '12px 8px',
      fontWeight: 400,
      color: '#222',
      '&:last-child': {
        borderRight: "0px solid #d6d6d6"
      }
    }
    // '&:last-child': {
    // 	'& td,& th': {
    // 		borderRight: `1px solid #F8F8F8`,
    // 	},
    // },
  });
}, "");
const StyledTableCell = /*#__PURE__*/_styled(TableCell, {
  shouldForwardProp: isStyledPropsValid,
  target: "erzejn95"
})(_ref4 => {
  let {
    theme,
    title,
    isFixed,
    checkbox,
    index,
    cellWidth,
    maxWidth,
    lastFixedItem,
    isHeader,
    leftDistance = 0,
    rowIndex,
    rows,
    verticalAlign
  } = _ref4;
  const zIndex = getZIndex({
    isHeader,
    isFixed,
    rows,
    rowIndex
  });
  return _objectSpread2(_objectSpread2({
    title: undefined,
    background: theme.customColors.white,
    position: isHeader || isFixed ? 'sticky' : 'relative',
    minWidth: cellWidth ? "".concat(cellWidth, "px") : 'unset',
    width: maxWidth ? "".concat(maxWidth, "px") : 'max-content',
    color: isHeader ? '#000' : '#555555',
    fontWeight: isHeader ? 500 : 300,
    fontSize: isHeader ? 14 : 12,
    // borderRight: `1px solid #F8F8F8`,
    verticalAlign: verticalAlign || 'middle',
    borderBottom: 0,
    zIndex
  }, isFixed && {
    left: "".concat(leftDistance, "px")
  }), {}, {
    // '&:hover': {
    // 	zIndex: zIndex + 4,
    // },
    // 要是是欄位fix的table 並且是最後一行fix欄位
    '&:before': _objectSpread2({}, isFixed && (index === lastFixedItem || rowIndex === lastFixedItem) && {
      content: '""',
      height: '100%',
      width: '35px',
      background: 'linear-gradient(270deg, rgba(230, 230, 230, 0.00) 75%, rgba(230, 230, 230, 0.15) 100%)',
      position: 'absolute',
      display: 'block',
      right: '-33px',
      top: 0,
      bottom: 0
    }),
    '&:last-child': {
      borderRight: "0px solid #d6d6d6"
    },
    '> span': {
      alignItems: 'flex-start'
    }
  });
}, "");
const StyledTableHead = /*#__PURE__*/_styled(TableHead, {
  shouldForwardProp: isStyledPropsValid,
  target: "erzejn94"
})(_ref5 => {
  return {
    '& th': {
      backgroundColor: 'white',
      borderBottom: '1px solid #E6E6E6',
      color: '#000',
      fontSize: '12px',
      padding: '12px 8px',
      lineHeight: '1rem',
      verticalAlign: 'top'
    }
  };
}, "");
const StyledTableBody = /*#__PURE__*/_styled(TableBody, {
  shouldForwardProp: isStyledPropsValid,
  target: "erzejn93"
})(_ref6 => {
  return {};
}, "");
const StyledRowLoading = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "erzejn92"
})(_ref7 => {
  let {
    theme,
    rowIndex,
    rows
  } = _ref7;
  const zIndex = getZIndex({
    isHeader: false,
    isFixed: true,
    rows,
    rowIndex,
    isLoading: true
  });
  return {
    position: 'absolute !important',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
    width: '100%',
    background: "".concat(alpha(theme.customColors.white, 0.7)),
    zIndex: zIndex + 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.customColors.purple[500],
    fontWeight: "700 !important",
    '&::after': {
      background: 'transparent !important'
    }
  };
}, "");
const StyledTableFoot = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "erzejn91"
})(_ref8 => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    padding: '12px 21px',
    height: '40px',
    borderTop: '1px solid #E6E6E6',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px'
  };
}, "");
const StyledSkeleton = /*#__PURE__*/_styled(Skeleton, {
  target: "erzejn90"
})(_ref9 => {
  let {
    theme,
    sx
  } = _ref9;
  return _objectSpread2({
    height: '16px',
    width: '100%',
    backgroundColor: theme.palette.grey[200],
    // 更改背景顏色
    borderRadius: '99px',
    transform: 'none'
  }, sx);
}, "");
export { StyledRowLoading, StyledSkeleton, StyledTable, StyledTableBody, StyledTableCell, StyledTableFoot, StyledTableHead, StyledTableRow };